import { Component } from '@angular/core'

@Component({
  selector: 'address',
  imports: [],
  templateUrl: './address.component.html',
  styleUrl: './address.component.scss',
  standalone: true,
})
export class AddressComponent {}
